import './ImageDescriptor.css';

const ImageDescriptor = ({ label, year, src, children }) => (
  <fieldset className="ImageDescriptor">
    <legend>{label} - {year}</legend>
    <img src={src} alt={children} />
    {children}
  </fieldset>
);

export default ImageDescriptor;
